<div class="tablenav">
  <div>
    <button class="btndel" (click)="deleteSelected()" *ngIf="canAccessComponent(AccessRights.EDITUSERS)">
      {{'Delete selected'|translate }}
        <span *ngIf="items != null">
            ({{itemsCount()}})
        </span>
    </button>
  </div>
  <app-pagination [viewmode]="viewMode" (onExport)="onExport($event)" [printElementID]="printElementID"
                  [items]="items" (onPageChange)="pageChange($event)">
    <ng-content select="[export]" export></ng-content>
  </app-pagination>
</div>
